import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Login from './Login';
import Dashboard from './Dashboard';
import Slots from './Slots';
import 'antd/dist/reset.css'; // for v5 reset style
import User from './user';
import MeetingsTable from './Meetings';
import Data from './Data';
import Web from './Web';
import UpdateProfile from './UpdateProfile';
import CreateAccount from './SignUp';
import Accounts from './Accounts';
import ViewLink from './Link';
import ErrorPage from './Error';
import Payment from './Payment';
import PlanDetails from './Booking';
import QrPage from './QrCode';
import PaymentQR from './QrCode';

const theme = extendTheme({
  fonts: {
    heading: 'Poppins, sans-serif',
    body: 'Poppins, sans-serif',
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router basename="/partner">
        <Routes>
  <Route path="/" element={<Login />} />
  <Route path="/:id/:slug" element={<Login />} />
  <Route path="/dashboard" element={<Dashboard />} />
  <Route path="/slots" element={<Slots />} />
  <Route path="/user" element={<User />} />
  <Route path="/meetings" element={<MeetingsTable />} />
  <Route path="/data" element={<Data />} />
  <Route path="/web" element={<Web />} />
  <Route path="/update-profile/:id" element={<UpdateProfile />} />
    <Route path="*" element={<ErrorPage />} />
  <Route path="/signup" element={<CreateAccount />} />
   <Route path="/view-link" element={<ViewLink />} />
  <Route path="/accounts" element={<Accounts />} />
   <Route path="/pricing" element={<Payment />} />
    <Route path="/final-booking" element={<PaymentQR />} />
  <Route path="/plan/:type" element={<PlanDetails />} />
</Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;
